import Styled, { css } from "styled-components";

import { ITheme } from "../../interface";
import { screenSize } from "../../constant";
const { maxWidth } = screenSize;

export const Title = Styled.h2<{ $props: { showMyExperience: boolean } }>`
  ${({ $props }) => {
    const { showMyExperience } = $props;

    return css`
      transform: translateX(${showMyExperience ? 0 : -50}%);
      opacity: ${showMyExperience ? 1 : 0};
    `;
  }}
  transition: all 0.2s ease-in-out 0s;
  width: max-content;
  font-size: 2em;
  margin: 0;
  @media screen and (max-width: ${maxWidth.mediumPhoneV1}){
    font-size: 1.5em;
  }
`;

export const Highlight = Styled.span<{ $props: { theme: ITheme } }>`
  transition: all 0.2s ease-in-out 0s;
  ${({ $props }) => {
    const { theme } = $props;

    return css`
      color: ${theme.colors.hightlightFont};
    `;
  }}
`;

export const TextSlideShow = Styled.div`
    height: 50px;
    max-width: 95%;
    margin: 0 auto;
    position: relative;
    overflow: hidden;
    transform: translate3d(0, 0, 0);
`
export const TextSlideMover = Styled.td`
    height: 10px;
    width: 256px;
    position: absolute;
    white-space: nowrap;
    top: 0;
    left: 0;
    transform: translate3d(0, 0, 0);
    animation: moveSlideshow 5s linear infinite;
    @keyframes moveSlideshow {
        100% {
            transform: translateX(-66.6666%);
        }
    }
`